import { PropsWithChildren, useMemo } from 'react';

import { BottomTabMenuItem } from '@opositandopn/ui';
import classnames from 'classnames';
import { IoPodiumOutline } from 'react-icons/io5';

import { BaseComponentProps } from '../../../../types/base-component.types';
import {
  AssessmentSurveyPreviewModel,
  GetAssessmentSurveysRequest,
  useGetAssessmentSurveys,
} from '../../api/useSurveys';

import styles from './AssessmentSurveyBottomTabItem.module.scss';

export interface AssessmentSurveyFormValues {
  estimatedGrade: number;
}

type ContainerProps = BaseComponentProps & {
  subjectId: string;
  onClick: (id: string) => void;
};

function AssessmentSurveyBottomTabItem({
  className,
  subjectId,
  onClick,
  children,
}: PropsWithChildren<ContainerProps>) {
  const filter = useMemo<GetAssessmentSurveysRequest>(
    () => ({
      subjectId,
      pageNumber: 1,
      pageSize: 1,
      fromTime: new Date(new Date().setMonth(new Date().getMonth() - 12)),
      toTime: new Date(),
      sort: '-releaseDate',
    }),
    [subjectId],
  );

  const { data: response } = useGetAssessmentSurveys(filter);

  const currenSurvey: AssessmentSurveyPreviewModel | undefined =
    response?.items?.[0];

  if (
    currenSurvey &&
    currenSurvey.releaseDate < new Date() &&
    currenSurvey.dueDate &&
    currenSurvey.dueDate > new Date()
  ) {
    return (
      <>
        <BottomTabMenuItem
          icon={<IoPodiumOutline />}
          className={classnames(styles['warning'], className)}
          onClick={() => onClick(currenSurvey.id)}
        >
          {children}
        </BottomTabMenuItem>
      </>
    );
  }

  return null;
}

export { AssessmentSurveyBottomTabItem };
